import { Component } from '@angular/core';
import { CrudPagedListComponent } from '../_directives';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { AlertService, CancelReasonCategoryService, UserService } from '../_services';
import { Observable } from 'rxjs';
import { ReasonCategory, User } from '../_models';
import { config } from '../../config/config';
import { takeUntil } from 'rxjs/operators';

@Component({
  moduleId: module.id,
  selector: 'reason-category',
  templateUrl: './reason-category.component.html'
})
export class ReasonCategoryComponent extends CrudPagedListComponent {
  reasonCategories$: Observable<ReasonCategory[]> = this.data$;
  currentUser: User;
  pageSize = config.maxPageSize;

  constructor(
    protected router: Router,
    protected location: Location,
    protected route: ActivatedRoute,
    protected cancelReasonCategoriesService: CancelReasonCategoryService,
    protected userService: UserService,
    protected alertService: AlertService
  ) {
    super(router, location, route, cancelReasonCategoriesService, alertService);
    this.title = 'Reason Categories';
    this.objectName = 'reason category';
  }

  ngOnInit() {
    super.ngOnInit();

    this.userService.getCurrent()
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (user: User) => {
          this.currentUser = user;
        },
        error => {
          this.handleError(error);
        }
      );
  }

  protected runInitialQuery() {
    this.queryData();
  }
}
